import { NativeSelect } from '@mui/material';
import { allStatuses, allAppStatuses } from './filterConfig';

const StatusInputField = ({ currentFilter, setCurrentFilter, headerName = null }) => {
	const statusesByHeader = headerName === 'Application Status' ? allAppStatuses : allStatuses;

	return (
		<NativeSelect
			sx={{ fontSize: '14px' }}
			value={currentFilter.value ?? ''}
			inputProps={{ name: 'value' }}
			onChange={(e) => {
				setCurrentFilter({ ...currentFilter, value: e.target.value });
			}}
		>
			{statusesByHeader?.map((e) => (
				<option key={`status-${e.value}`} value={e.value}>
					{e?.label}
				</option>
			))}
		</NativeSelect>
	);
};

export default StatusInputField;
